import {
    usePostServiceOrdersCompletionsMutation,
    usePostServiceOrdersStartInfosMutation,
} from '../../../api/serviceOrdersApi';
import { trimmedOrUndefined } from '../../../api/utils';
import { CollectedAccessories } from '../accessory.types';

export type ServiceOrderExecutionUpdate = {
    readonly orderIds: Iterable<string>;
    readonly startedAt: Date | undefined;
    readonly completedAt: Date | undefined;
    readonly generalInformation?: string;
    readonly collectedAccessories?: CollectedAccessories;
};

export type ServiceOrderExecutionSuccessMessageId =
    | 'outboundPortal.notification.serviceOrder.start.info'
    | 'outboundPortal.notification.serviceOrder.completion.success';

export const useServiceOrderExecutionUpdate = () => {
    const [updateStartInfo, startInfoRequest] = usePostServiceOrdersStartInfosMutation();
    const [updateCompletion, completionRequest] = usePostServiceOrdersCompletionsMutation();

    const updateExecution = async ({
        orderIds,
        startedAt,
        completedAt,
        generalInformation,
        collectedAccessories,
    }: ServiceOrderExecutionUpdate): Promise<ServiceOrderExecutionSuccessMessageId> => {
        const commonPayload = {
            orderIds: new Set(orderIds),
            startedAt,
            generalInformation: trimmedOrUndefined(generalInformation),
            collectedAccessories,
        };

        if (completedAt === undefined) {
            if (startedAt === undefined) {
                throw new Error('A start date is required when updating service order start information');
            }

            await updateStartInfo({ ...commonPayload, startedAt }).unwrap();
            return 'outboundPortal.notification.serviceOrder.start.info';
        }

        await updateCompletion({ ...commonPayload, completedAt }).unwrap();
        return 'outboundPortal.notification.serviceOrder.completion.success';
    };

    return {
        updateExecution,
        isLoading: startInfoRequest.isLoading || completionRequest.isLoading,
    };
};
